import {createContext, ReactNode, useContext, useEffect, useState} from "react";
import {usePathname} from "next/navigation";

interface HeaderContextProps {
    content: ReactNode
    setContent: (content: ReactNode) => void;
}

const HeaderContext = createContext<HeaderContextProps|undefined>(undefined);

export function useHeader(): HeaderContextProps {
    const context = useContext(HeaderContext);
    if (!context) {
        throw new Error("useHeader must be used within an HeaderContext");
    }
    return context;
}

interface HeaderProviderProps {
    children: ReactNode
}

export function HeaderProvider({children}: HeaderProviderProps) {
    const [content, setContent] = useState<ReactNode|null>(null);
    const pathname = usePathname();
    const [currentPathname, setCurrentPathname] = useState<string>(pathname);

    useEffect(() => {
        if (content && pathname !== currentPathname) {
            setContent(null);
        }
    }, [content, pathname, currentPathname]);

    const value = {
        content,
        setContent
    }
    return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
}